<div>
    <me-landing-page-hero *ngIf="data['landingPageHero']['component']" [data]="data['landingPageHero']"></me-landing-page-hero>
    <me-landing-page-text *ngIf="data['landingPageText']['component']" [data]="data['landingPageText']" ></me-landing-page-text>
    <me-landing-page-faq *ngIf="data['faqSection']['component']" [data]="data['faqSection']" ></me-landing-page-faq>
    <me-landing-page-how-it-works *ngIf="data['landingPageHowItWorks']['component']" [data]="data['landingPageHowItWorks']" ></me-landing-page-how-it-works>
    <me-landing-page-marquee *ngIf="data['landingPageMarquee']['component']" [data]="data['landingPageMarquee']" ></me-landing-page-marquee>
    <me-landing-page-proof *ngIf="data['landingPageProof']['component']" [data]="data['landingPageProof']" ></me-landing-page-proof>
    <me-landing-page-data *ngIf="data['landingPageData']['component']" [data]="data['landingPageData']" ></me-landing-page-data>
    <me-landing-page-quote *ngIf="data['landingPageQuote']['component']" [data]="data['landingPageQuote']" ></me-landing-page-quote>
    <me-landing-page-image-text *ngIf="data['landingPageImageText']['component']" [data]="data['landingPageImageText']" ></me-landing-page-image-text>
    <me-landing-page-expert *ngIf="data['therapistsSection']['component']" [data]="data['therapistsSection']" ></me-landing-page-expert>
</div>

<div id="modalChangeLanguage" #myDiv bsModal #modalChangeLanguage="bs-modal" class="modal fade modal-confirmation modal-change-language" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-confirmation-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body">
                <div class="modal-body__header">
                    {{ 'We have a product adapted for Switzerland' | translate }}
                    <br/>
                    {{ 'Would you like to be redirected there?' | translate }}
                </div>
                <div class="modal-body__button">
                    <button type="button " class="btn btn--secondary" (click)="closeLanguageModal()">
                        {{ 'Cancel' | translate }}
                    </button>
                    <button type="button" class="btn btn--primary" (click)="changeToSwitze()">
                        {{ 'Next' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
